export default __webpack_public_path__ + "static/media/116-BF-502.d9707c02.png";